import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of } from 'rxjs';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
declare var $: any;
import { debounceTime } from "rxjs/operators";
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { emailPattern, mobilePattern, noWhitespaceInRequiredValidator, splitPattern } from '../../shared/constants';
/* import { SignaturePadComponent } from '@almothafar/angular-signature-pad'; */
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

@Component({
	selector: 'app-company-create',
	templateUrl: './company-create.component.html',
	styleUrl: './company-create.component.css'
})
export class CompanyCreateComponent implements OnInit, AfterViewInit {
	breadcrumbList = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		/* {
			path: '/app/dashboard-mdm',
			name: "MDM"
		}, */
		{
			path: "/app/company",
			name: "Companies"
		}
	];
	uId: any = null;
	pagetitle = "Create Company";
	moduleForm!: FormGroup;
	showLoader: boolean = false;
	showDeleteLoader: boolean = false;
	pageLoading: boolean = false;
	details: any = null;
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted: boolean = false;
	user_type: any = "";
	accessLoader = false;
	mailIdPlaceholder = "Please add email address and press space bar.";
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	emailPatternValidator(control: FormControl) {
		if (!control.value.match(emailPattern)) {
			return {
				'emailerr': true
			};
		}
		return null;
	}
	splitPattern = splitPattern;

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe({
			next: (data: any) => {
				this.accessLoader = false;
				try {
					this.user_type = data.res[0].user_type;
					/* let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
					this.UserModuleAccess = accessObj["USER_Module"]; */
				} catch (error) { }
			}, error: (error: any) => {
				this.accessLoader = false;
				/* this.UserModuleAccess = "NoAccess"; */
			}
		});
	}
	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"] == undefined ? null : routeParams["uId"];
			this.moduleForm = this.formBuilder.group({
				name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				email: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(emailPattern)]],
				phone_no: [null, [Validators.required, noWhitespaceInRequiredValidator, Validators.pattern(mobilePattern)]],
				address: [null, [Validators.required, noWhitespaceInRequiredValidator]],
				com_ccemail: [null]
			})
			if (this.uId) {
				this.breadcrumbList.push({ path: "/app/edit-company/" + this.uId, name: "Edit Company" });
				this.pagetitle = "Edit Company";
				this.getDetails();
			} else {
				this.breadcrumbList.push({ path: "/app/create-company", name: "Add Company" });
			}
		});
	}

	formChanged() {
		this.moduleForm.markAsDirty();
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getCompanyDetails({ "id": this.uId }).subscribe((data: any) => {
			this.pageLoading = false;
			this.details = data.data;
			this.f.name.setValue(this.details.name);
			this.f.email.setValue(this.details.email);
			this.f.phone_no.setValue(this.details.phone_no);
			this.f.address.setValue(this.details.address);
			this.f.com_ccemail.setValue(this.details.com_ccemail);
		}, (error) => {
			this.pageLoading = false;
			if (error.status == 401) { return }
			this.toastr.error("Unable to fetch details.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = {
			email: this.f.email.value,
			phone_no: this.f.phone_no.value,
			address: this.f.address.value,
			name: this.f.name.value,
			com_ccemail: this.f.com_ccemail.value ? this.f.com_ccemail.value : []
		};

		if (this.uId) {
			payload["id"] = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateCompany(payload).subscribe(data => {
			this.showLoader = false;
			this.toastr.success("Saved successfully.", 'Success', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			this.gotoList();
		}, (error: any) => {
			this.showLoader = false;
			if (error.status == 401) { return }
			if (error.status == 409) {
				Swal.fire({
					title: 'Already Exists',
					html: 'Company already exists. Do you want to restore it?',
					icon: 'question',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonText: 'Yes, Restore!',
					cancelButtonText: 'Cancel',
					confirmButtonColor: '#3e4fb1'
				}).then((result) => {
					if (result.value) {
						this.apiService.restoreCompany(error.error.id).subscribe((data: any) => {
							this.toastr.success("Company restored successfully", 'Success', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							this.gotoList();
						}, (error) => {
							this.toastr.error("Something went wrong", 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						});
					} else if (result.dismiss === Swal.DismissReason.cancel) { }
				})
			} else {
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}

						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/company']);
	}
}
